<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Aviso
            </v-card-title>
            <v-card-text style="text-align: center" class="mt-3">
                <h2>¿Estás seguro que deseas eliminar?</h2>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn color="error" large @click="dialog = false"
                    >Cancelar</v-btn
                >
                <v-btn color="success" large @click="deleteItem()"
                    >Confirmar</v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ["value"],
    data() {
        return {
            dialog: false,
        };
    },
    created() {
        if (this.value != null) {
            this.dialog = this.value;
        }
    },
    watch: {
        value(val) {
            if (val != null) {
                this.dialog = val;
            }
        },
        dialog(val) {
            if (val != null) {
                this.$emit("input", val);
            }
        },
    },
    methods: {
        deleteItem() {
            this.$emit("delete");
        },
    },
};
</script>
